export class Redirect {
    constructor() {
        this.url = null;
        this.delay = 0;
    }
    /** timeoutID */
    timeout;
    /** Emitted before the actual redirect takes place, includes the URL, can be cancelled  */
    redirect;
    loadUrl() {
        const evt = this.redirect.emit(this.url);
        if (!evt.defaultPrevented) {
            window.location.href = this.url;
        }
    }
    setDelay() {
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(this.loadUrl.bind(this), this.delay * 1000);
    }
    componentDidLoad() {
        if (this.url === null) {
            return;
        }
        this.setDelay();
    }
    static get is() { return "ux-redirect"; }
    static get properties() {
        return {
            "url": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "url string where the user should be redirected to"
                },
                "attribute": "url",
                "reflect": false,
                "defaultValue": "null"
            },
            "delay": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "time until the redirect should occur in seconds"
                },
                "attribute": "delay",
                "reflect": false,
                "defaultValue": "0"
            }
        };
    }
    static get events() {
        return [{
                "method": "redirect",
                "name": "uxRedirect",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted before the actual redirect takes place, includes the URL, can be cancelled"
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "delay",
                "methodName": "setDelay"
            }];
    }
}
//# sourceMappingURL=redirect.js.map
